<script>
    import { createYouTubeScript, onYouTubeIframeAPIReady } from "@/utils";
    import TheSlider from "@main/packages/TheSlider";
    import ProductTypographyVideoItem from "./ProductTypographyVideoItem";

    export default {
        name: "ProductTypographyVideo",
        components: { ProductTypographyVideoItem, TheSlider },
        props: {
            videoList: Array,
        },
        data() {
            return {
                options: {
                    lazy: true,
                },
                firstLoad: true,
            };
        },
        methods: {
            loadVideo({ videoId, id }) {
                if (this.firstLoad) {
                    createYouTubeScript({ videoId }, () => {
                        onYouTubeIframeAPIReady({ videoId, id }, (event) => {
                            event.target.playVideo();
                        });
                        this.firstLoad = false;
                    });
                } else {
                    onYouTubeIframeAPIReady({ videoId, id }, (event) => {
                        event.target.playVideo();
                    });
                }
            },
        },
    };
</script>

<template>
    <div class="product-typography-video">
        <h3 class="product-typography-video__title">Видео</h3>
        <the-slider
            name-slider="typography-video"
            :options="options"
            :list="videoList"
            :number-slides="1"
            is-scrollbar
        >
            <product-typography-video-item
                slot="swiper-slide"
                class="swiper-slide"
                v-for="(videoItem, i) in videoList"
                :key="i"
                :video-item="videoItem"
                @load-video="loadVideo"
            ></product-typography-video-item>
        </the-slider>
    </div>
</template>

<style lang="scss">
    .product__video__slider {
        display: none;
    }

    .product-typography-video {
        margin-top: 24px;
        margin-bottom: 24px;
        .c-slider__swiper {
            border-radius: var(--border-xl);
        }
    }

    .product-typography-video__title {
        font-weight: bold;
        font-size: 19px;
        line-height: 24px;
        margin-bottom: 16px;
    }
</style>
